import SwitchUiVersion from "components/v2/Buttons/SwitchUiVersion";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { createStructuredSelector } from "reselect";

import styles from "./style.module.css";

const SwitchVersion = ({ isNewVersionEnabled = false }) => {
  const [isHidden, setIsHidden] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname) {
      setIsHidden(location.pathname.startsWith("/studio"));
    } else {
      setIsHidden(false);
    }
  }, [location.pathname]);

  if (!isHidden) {
    return <SwitchUiVersion isNewVersionEnabled={isNewVersionEnabled} containerClassName={styles.container} />;
  }

  return null;
};

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SwitchVersion);
